export default {
pdd58e30: "M15 0L18.3677 10.0193L29.2658 10.0193L20.4491 16.2115L23.8168 26.2307L15 20.0385L6.18322 26.2307L9.55093 16.2115L0.734152 10.0193L11.6323 10.0193L15 0Z",
}
